var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLock(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#5E5E66",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2043 4.27071C8.6982 3.7768 9.36808 3.49933 10.0666 3.49933C10.765 3.49933 11.4349 3.7768 11.9288 4.27071C12.4227 4.76461 12.7002 5.43449 12.7002 6.13297V7.79985H7.43292V6.13297C7.43292 5.43449 7.71039 4.76461 8.2043 4.27071ZM6.67873 9.29985C6.68013 9.29986 6.68152 9.29986 6.68292 9.29986C6.68431 9.29986 6.68571 9.29986 6.68711 9.29985H13.446C13.4474 9.29986 13.4488 9.29986 13.4502 9.29986C13.4516 9.29986 13.453 9.29986 13.4544 9.29985H14.6336V16.5007H5.49933V9.29985H6.67873ZM5.93292 7.79985V6.13297C5.93292 5.03666 6.36843 3.98525 7.14363 3.21005C7.91884 2.43484 8.97025 1.99933 10.0666 1.99933C11.1629 1.99933 12.2143 2.43484 12.9895 3.21005C13.7647 3.98525 14.2002 5.03666 14.2002 6.13297V7.79985H15.3836C15.7979 7.79985 16.1336 8.13564 16.1336 8.54985V17.2507C16.1336 17.6649 15.7979 18.0007 15.3836 18.0007H4.74933C4.33512 18.0007 3.99933 17.6649 3.99933 17.2507V8.54985C3.99933 8.13564 4.33512 7.79985 4.74933 7.79985H5.93292Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.ab63377c.svg";
export { ForwardRef as ReactComponent };